import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any) => {
  console.log('htaf data', data)
  if (isStatusOK(data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const getDmtAvailableLimitReq = (customerId: any) => {
  return {
    productCode: 'DMR',
    subProductCode: 'C2A',
    customerId: customerId || RootStore?.customerDetails?.newRemittanceUserId,
    customerType: 'REMITTER',
    transactionDate: new Date().toISOString().replace('T', ' ').slice(0, 23),
  }
}

export const getDmtAvailableLimitApi = (tokens: any, remitanceUserId: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  const request: Request<{}> = {
    apiPath: APIEndPoints.getDmtAvailableLimitApi,
    method: 'POST',
    config: config,
    body: getDmtAvailableLimitReq(remitanceUserId),
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })

  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
